import { routeBuilder } from "../../../user.InterfaceLayer/router/services/routeBuilder.service";
import CabinetRoutesPaths from "../../../user.InterfaceLayer/router/routes/cabinet.route/cabinet.routesPaths";
import { ReactComponent as ProfileIcon } from "../../../general/constants/icons/profile.svg";
import { ReactComponent as EventIcon } from "../../../general/constants/icons/events.svg";
import { ReactComponent as OpenFolderIcon } from "src/general/constants/icons/OpenFolderBlack.svg";
import { ReactComponent as LoyaltyProgramIcon } from "../../../general/constants/icons/loyaltyProgram.svg";
import { ReactComponent as TestIcon } from "../../../general/constants/icons/test.svg";
import { ReactComponent as AssociationIcon } from "../../../general/constants/icons/associationNew.svg";
import { ReactComponent as DocumentIcon } from "../../../general/constants/icons/documents.svg";
import { ReactComponent as NotificationsIcon } from "../../../general/constants/icons/notification.svg";
import COMMON_FIELDS from "../commonFields";

const navMenu = [
	{
		[COMMON_FIELDS.ID]: 1,
		[COMMON_FIELDS.KEY]: routeBuilder([CabinetRoutesPaths.MAIN]),
		[COMMON_FIELDS.LABEL]: "Профиль",
		activeNav: [],
		[COMMON_FIELDS.ICON]: ProfileIcon,
	},
	{
		[COMMON_FIELDS.ID]: 2,
		[COMMON_FIELDS.KEY]: routeBuilder([CabinetRoutesPaths.EVENTS]),
		[COMMON_FIELDS.LABEL]: "Мои мероприятия",
		activeNav: [],
		[COMMON_FIELDS.ICON]: EventIcon,
	},
	{
		[COMMON_FIELDS.ID]: 3,
		[COMMON_FIELDS.KEY]: routeBuilder([CabinetRoutesPaths.LOYALTY_PROGRAM]),
		[COMMON_FIELDS.LABEL]: "Программа лояльности",
		activeNav: [],
		[COMMON_FIELDS.ICON]: LoyaltyProgramIcon,
	},
	{
		[COMMON_FIELDS.ID]: 4,
		[COMMON_FIELDS.KEY]: routeBuilder([CabinetRoutesPaths.TESTS]),
		[COMMON_FIELDS.LABEL]: "Тесты",
		activeNav: [],
		[COMMON_FIELDS.ICON]: TestIcon,
	},
	{
		[COMMON_FIELDS.ID]: 5,
		[COMMON_FIELDS.KEY]: routeBuilder([CabinetRoutesPaths.MATERIALS]),
		[COMMON_FIELDS.LABEL]: "Учебные материалы",
		activeNav: [],
		[COMMON_FIELDS.ICON]: OpenFolderIcon,
	},
	{
		[COMMON_FIELDS.ID]: 6,
		[COMMON_FIELDS.KEY]: routeBuilder([CabinetRoutesPaths.ASSOCIATION]),
		[COMMON_FIELDS.LABEL]: "Ассоциация",
		activeNav: [],
		[COMMON_FIELDS.ICON]: AssociationIcon,
	},
	// {
	// 	[COMMON_FIELDS.ID]: 7,
	// 	[COMMON_FIELDS.KEY]: routeBuilder([CabinetRoutesPaths.DOCUMENTS]),
	// 	[COMMON_FIELDS.LABEL]: "Документы",
	// 	activeNav: [],
	// 	[COMMON_FIELDS.ICON]: DocumentIcon,
	// },
	{
		[COMMON_FIELDS.ID]: 8,
		[COMMON_FIELDS.KEY]: routeBuilder([CabinetRoutesPaths.NOTIFICATION]),
		[COMMON_FIELDS.LABEL]: "Уведомления",
		activeNav: [],
		[COMMON_FIELDS.ICON]: NotificationsIcon,
	},
];

export default navMenu;
